import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute('/(redirects)/aboutus')({
  beforeLoad: () => {
    throw redirect({ to: '/about', replace: true });
  },
})
